import { z } from "zod";

export const InterviewResponseSchema = z.enum([
  "accept",
  "request_new_time",
  "decline",
]);

export type InterviewResponse = z.infer<typeof InterviewResponseSchema>;

export const INTERVIEW_STATUS_BY_RESPONSE = {
  accept: "Accepted",
  request_new_time: "Rescheduled",
  decline: "Declined",
} as const satisfies Record<
  InterviewResponse,
  "Accepted" | "Rescheduled" | "Declined"
>;

export const RespondToInterviewQuerySchema = z.object({
  conversationId: z.string(),
});

export const RespondToInterviewBodySchema = z.object({
  interviewId: z.string(),
  response: InterviewResponseSchema,
});

export const RespondToInterviewResponseSchema = z.object({});

export type RespondToInterviewResponseDto = z.infer<
  typeof RespondToInterviewResponseSchema
>;
